export enum DLTargetSelectors {
  Tab = '.gtm-tab',
  Scroll = '.gtm-scroll',
  Headline = '.gtm-headline',
  TabTitle = '.gtm-tab-title',
  Anchor = 'a',
  CTA = 'button.MuiButton-root',
}

export enum DLTabsEventNames {
  TabClick = 'tabs_nav_click',
  CtaClick = 'tabs_cta_click',
  LinkClick = 'tabs_link_click',
  CarouselNavClick = 'list_card_carousel_nav_click',
}

export enum DLTabsEvents {
  TabClick = 'trackEvent-tabsNavClick',
  CtaClick = 'trackEvent-tabsCtaClick',
  LinkClick = 'trackEvent-tabsLinkClick',
  CarouselNavClick = 'trackEvent-listCardCarouselNavClick',
}
